/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PropertySearchResponse } from './PropertySearchResponse';
export type Subscription = {
    id: string;
    customer_id: string;
    customer_name: string | null;
    customer_email: string | null;
    auth0_user_id: string;
    quantity: number | null;
    unit_amount: number | null;
    past_due: boolean;
    per_seat: boolean;
    trial_end: string | null;
    cancel_at: string | null;
    admin_trial: boolean;
    ended_at: string | null;
    created: string;
    property_id: string | null;
    property_search_response: PropertySearchResponse | null;
    billing_cycle: Subscription.billing_cycle | null;
    products: Array<{
        unit_amount: number | null;
        quantity?: number | null;
        product_id: string;
    }>;
};
export namespace Subscription {
    export enum billing_cycle {
        MONTHLY = 'monthly',
        QUARTERLY = 'quarterly',
        BIANNUALLY = 'biannually',
        ANNUALLY = 'annually',
    }
}

